import React from 'react';
import { Image, Text, View } from 'react-native';
import { isValidPhotoURL } from '../utils/userPhoto';
import { displayNameFromUserLike, personInitials } from '../utils/personInitials';

/** Dark iMessage-style circle when a photo is missing. */
const INITIALS_BG = '#3a3a3a';

export function PersonAvatar({
  photoURL,
  name,
  email,
  uid,
  user,
  size = 40,
  style,
  textStyle,
  imageStyle,
  borderRadius,
}) {
  const label = name || displayNameFromUserLike(user);
  const initials = personInitials(label, email || user?.email || uid || user?.uid);
  const uri = photoURL || user?.photoURL;
  const radius = borderRadius ?? size / 2;
  const box = {
    width: size,
    height: size,
    borderRadius: radius,
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: INITIALS_BG,
  };

  if (isValidPhotoURL(uri)) {
    return (
      <Image
        source={{ uri: String(uri).trim() }}
        style={[box, style, imageStyle]}
      />
    );
  }

  return (
    <View style={[box, style]}>
      <Text
        style={[
          {
            color: '#ffffff',
            fontWeight: '700',
            fontSize: Math.max(10, Math.round(size * 0.36)),
            letterSpacing: 0.3,
          },
          textStyle,
        ]}
      >
        {initials}
      </Text>
    </View>
  );
}

export function avatarImageSource(content) {
  if (content && typeof content === 'object') return content;
  if (typeof content === 'string' && content.trim()) return { uri: content.trim() };
  return null;
}
